export default {
	methods: {
		notifySuccess(text) {
			this.$vs.notify({
				title: this.$t('successNotification'),
				text,
				iconPack: "feather",
				icon: "icon-alert-circle",
				color: "success",
				time: 10000,
			});
		},
		notifyDanger(text) {
			this.$vs.notify({
				title: this.$t('dangerNotification'),
				text,
				iconPack: "feather",
				icon: "icon-alert-circle",
				color: "danger",
				time: 10000
			});
		},
		notifyError(text) {
			this.$vs.notify({
				title: this.$t('errorNotification'),
				text,
				iconPack: "feather",
				icon: "icon-alert-circle",
				color: "danger",
				time: 10000
			});
		}
	}
}
